<template>
	<div class="flex flex-wrap">
		<div class="w-full sm:w-6/12 md:w-4/12 px-2 py-4 md:p-4">
			<div class="relative inline-flex align-middle w-full">
				<button id="lang-dropdown-1" class="text-white" style="transition:all .15s ease" type="button"
				        v-on:click="toggleDropdown()" ref="btnDropdownRef">
					<i id="lang-dropdown-2" class="fas fa-globe-europe text-xl"></i>
				</button>
				<div v-bind:class="{'hidden': !dropdownPopoverShow, 'block': dropdownPopoverShow}"
				     class="bg-gray-900 text-base z-50 float-left py-2 list-none text-center rounded shadow-lg mt-1"
				     style="min-width:3rem" ref="popoverDropdownRef">
					<a href="javascript:" @click="setLanguage('lv')"
					   class="text-sm py-2 px-4 font-normal block w-full whitespace-no-wrap bg-transparent text-white">
						LV
					</a>
					<a href="javascript:" @click="setLanguage('en')"
					   class="text-sm py-2 px-4 font-normal block w-full whitespace-no-wrap bg-transparent text-white">
						EN
					</a>
					<a href="javascript:" @click="setLanguage('ru')" v-if="false"
					   class="text-sm py-2 px-4 font-normal block w-full whitespace-no-wrap bg-transparent text-white">
						RU
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

	import Popper from "popper.js";

	export default {
		name: "dropdown",
		data() {
			return {
				dropdownPopoverShow: false
			}
		},
		methods: {
			toggleDropdown: function () {
				if (this.dropdownPopoverShow) {
					this.dropdownPopoverShow = false;
					document.getElementById('nav-menu-wrapper').classList.toggle('nav-menu-open-lang');

					return;
				}

				this.dropdownPopoverShow = true;
				document.getElementById('nav-menu-wrapper').classList.toggle('nav-menu-open-lang');

				const {btnDropdownRef, popoverDropdownRef} = this.$refs;

				new Popper(btnDropdownRef, popoverDropdownRef, {
					placement: "bottom-end",
				});
			},
			setLanguage: function (lang) {
				if (this.$store.state.currentLocale === lang) {
					return;
				}

				this.$router.push('/' + lang);
			},
		},
		created() {
			let self = this;
			document.addEventListener('click', function (event) {
				// Hacky workaround to close to dropdown on click outside
				if ((event.target.id !== 'lang-dropdown-1' && event.target.id !== 'lang-dropdown-2') && self.dropdownPopoverShow) {
					self.dropdownPopoverShow = false;
				}
			});
		},
	}
</script>
